import { Icon, IconColor } from "@/components/shared/Icon"
import RadioButton from "@/components/shared/RadioButton"

const AlertSoundRadioButton = ({
   id,
   label,
   value,
   checked,
   onChange,
}: {
   id: string
   label: string
   value: string
   checked: boolean
   onChange: (value: string) => void
}) => {
   return (
      <>
         <RadioButton
            label={label}
            name={label}
            id={id}
            value={value}
            checked={checked}
            onChange={(value) => {
               onChange(value)
            }}
         />
         {value === "none" && (
            <Icon
               size="16"
               color={IconColor.HONOLULU_BLUE}
               name="mute"
            />
         )}
      </>
   )
}

export default AlertSoundRadioButton
